import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormlyDurationLabelComponent} from './duration-label.component';
import {I18nModule} from '@spartacus/core';
import {FormlyModule} from '@ngx-formly/core';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    FormlyModule.forChild({
      wrappers: [{name: 'duration-label', component: FormlyDurationLabelComponent}],
    }),
    FormlyDurationLabelComponent,
  ],
})
export class FormlyDurationLabelModule {}
